import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { MaskedLine } from "@/components/Reveal";

export default function ThankYou() {
  const { state } = useLocation();
  const isVisit = state?.mode === "site_visit";

  useEffect(() => {
    document.title = "Request Received | Rogers American Construction";
  }, []);

  return (
    <main className="min-h-screen flex flex-col justify-center px-6 md:px-12 pt-24 pb-16" data-testid="thank-you-page">
      <CheckCircle2 className="w-10 h-10 text-accent mb-8" strokeWidth={1.5} data-testid="thank-you-icon" />
      <h1 className="font-display font-medium uppercase leading-[0.92] tracking-tighter text-[11vw] md:text-[6.5vw]" data-testid="thank-you-title">
        <MaskedLine delay={0.1}>Request</MaskedLine>
        <MaskedLine delay={0.26}>received.</MaskedLine>
      </h1>
      <p className="mt-8 max-w-xl text-smoke text-base md:text-lg leading-relaxed" data-testid="thank-you-copy">
        {isVisit
          ? "Your site visit request is in. We will call or email within one business day to lock in a time — including evenings and weekends if that is what you picked."
          : "Your quote request is in. A person on our team reviews it within one business day and follows up by phone or email with next steps."}
      </p>
      <div className="mt-12 flex flex-wrap gap-4">
        <Link
          to="/"
          data-testid="thank-you-home-button"
          className="group inline-flex items-center gap-3 bg-ink text-paper font-semibold uppercase tracking-widest text-sm px-8 py-4 hover:bg-accent transition-colors"
        >
          Back to the site
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </main>
  );
}
